import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { VisaTypeCreateDto, VisaTypeUpdateDto } from '../dtos/visaType/visaTypeDto';

@Injectable({
  providedIn: 'root'
})
export class VisaTypeService {
  private apiUrl = `${environment.apiUrl}/visaType`;

  constructor(private http: HttpClient) {}

  // Get list of Visa Types
  getList(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}`);
  }

  //get by country Id
  getByCountryId(countryId: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${countryId}`);
  }

  // Create new Visa Type
  create(entity: VisaTypeCreateDto): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}`, entity);
  }

  // Update Visa Type
  update(id: number, entity: VisaTypeUpdateDto): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}`, entity);
  }

  // Delete Visa Type by Id
  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`);
  }
}
